import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import type { Props as SliderProps } from '@swf/components/Slider/Slider';
import Slider from '@swf/components/Slider/Slider';
import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';
import type { HgClubInfo, ScheduledTourn } from '@swf/generated/types/api/v0/SwHomeGames';
import { Image, PokerContext } from '@swf/poker';

import WebPokerGame from '../../WebPokerGame/WebPokerGame';
import ScheduledTime from '../ScheduledTime/ScheduledTime';

import { TXTCLI_My_Scheduled_Tournaments } from './ScheduledTournaments.messages.json';
import styles from './ScheduledTournaments.scss';

export interface Props {
  tournaments: ScheduledTourn[];
  clubs: HgClubInfo[];
}

interface StarsWeb {
  homegames: {
    openTourn: (obj: object | undefined) => void;
  };
}

interface ContainerProps extends SliderProps {
  isMobile: boolean;
}

const Container: React.FC<ContainerProps> = ({ isMobile, children, ...rest }) =>
  isMobile ? (
    <Slider {...rest}>{children}</Slider>
  ) : (
    <div className={styles.sliderDesktop}>{children}</div>
  );

const ScheduledTournaments: React.FC<Props> = ({ clubs, tournaments }) => {
  const isMobile = useSelector(select.device.isMobile);
  const { state, setState } = useContext(PokerContext);
  const { activeGameIds } = state;
  const isEmbedded = useSelector(select.site.isEmbedded);

  const handleGameClick = (id: string, clubId: number | undefined) => {
    if (isEmbedded) {
      const starsWeb = window.starsweb as StarsWeb;
      starsWeb?.homegames?.openTourn({
        clubId,
        tournId: id
      });
    } else {
      setState({ ...state, activeGameIds: [...activeGameIds, id] });
    }
  };

  return (
    <section className={styles.container}>
      <h3 className={styles.title}>
        <Translation {...TXTCLI_My_Scheduled_Tournaments} />
      </h3>

      <Container isMobile={isMobile} innerClassName={styles.innerSlider} className={styles.slider}>
        {tournaments.map(({ tournId, clubId, server, serverObject, startTime, tournName }) => {
          const club = clubs.find((club) => club.clubId === clubId);
          const id = `${tournId}`;

          return (
            <article
              onClick={() => handleGameClick(id, club?.clubId)}
              key={id}
              className={styles.itemContainer}
            >
              <div className={styles.avatar}>
                <Image imageByteArray={club?.clubImage} />
              </div>
              <div className={styles.gameTitle}>{tournName}</div>
              <div className={styles.time}>
                <ScheduledTime startTime={startTime as string} />
              </div>
              {activeGameIds.includes(id) && (
                <WebPokerGame
                  id={id}
                  serverAddress={server as string}
                  serverObjectName={serverObject as string}
                  type={'tournament'}
                  newTab={false}
                />
              )}
            </article>
          );
        })}
      </Container>
    </section>
  );
};
export default ScheduledTournaments;
